module.exports = __webpack_public_path__ + "static/img/HCC.297a649.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/leven/HCC.png
// module id = Gguq
// module chunks = 1